import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks';
import {
  selectLastUpdatedChart,
  refreshOrderFlow,
} from '../../../../../../../slices/utils/utilsSlice';
import { getTimeDiff } from '../../../../../../../components/Notifications/utils';

export default function OrderFlowRefresh() {
  const dispatch = useAppDispatch();
  const lastUpdated = useAppSelector(selectLastUpdatedChart);

  return (
    <ListItemButton onClick={() => dispatch(refreshOrderFlow(true))}>
      <ListItemIcon>
        <Icon>refresh</Icon>
      </ListItemIcon>
      <ListItemText
        primary="Refresh data"
        secondary={lastUpdated && `Last updated: ${getTimeDiff(lastUpdated.toString())}`}
      />
    </ListItemButton>
  );
}
